module.exports = __webpack_public_path__ + "img/icon_home_logo.6f1e0e8e.png";